// Dominio propio con SSL (Nginx en el VPS enruta a vendia-service-dev, puerto interno 3004) —
// reemplaza la IP:puerto directa que se usaba antes de que existiera este dominio.
export const environment = {
  production: false,
  apiUrl: 'https://dev-api.vendia.com.co/api/v1',
  socketUrl: 'https://dev-api.vendia.com.co',
};
